<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section', block.bgcolour]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <div class="columns is-variable is-6">
            <div class="column is-4">
                <h2 :class="['title', block.title_colour]">{{block.title}}</h2>
            </div>
            <div class="column is-8">
                <div class="content" v-if="block.content" ref="content" v-html="block.content"></div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
export default {
    name    :   'TitleContentSideBySideBlock',
    mixins  :   [ BlockCommons ],
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/TitleContentSideBySideBlock.vue